'use strict';

var display = require('@pixi/display');
var typedSignals = require('typed-signals');
var List = require('./List.js');

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class RadioGroup extends display.Container {
  constructor(options) {
    super();
    __publicField(this, "items", []);
    /** {@link List}, that holds and control all inned checkboxes.  */
    __publicField(this, "innerView");
    /** Text value of the selected item. */
    __publicField(this, "value");
    /** ID of the selected item. */
    __publicField(this, "selected");
    /** Fires, when new item is selected. */
    __publicField(this, "onChange");
    __publicField(this, "options");
    if (options) {
      this.init(options);
    }
    this.onChange = new typedSignals.Signal();
  }
  /**
   * Initiates a group.
   * @param options
   */
  init(options) {
    this.options = options;
    this.value = options.items[options.selectedItem || 0].label.text;
    this.selected = options.selectedItem ?? 0;
    if (this.innerView) {
      this.innerView.type = options.type;
      this.innerView.elementsMargin = options.elementsMargin;
    } else {
      this.innerView = new List.List({
        type: options.type,
        elementsMargin: options.elementsMargin
      });
    }
    this.addItems(options.items);
    this.addChild(this.innerView);
    this.selectItem(this.selected);
  }
  /**
   * Add items to a group.
   * @param {CheckBox[]} items - array of {@link CheckBox} instances.
   */
  addItems(items) {
    items.forEach((checkBox, id) => {
      checkBox.onChange.connect(() => this.selectItem(id));
      this.items.push(checkBox);
      this.innerView.addChild(checkBox);
    });
  }
  /**
   * Remove items from a group.
   * @param ids
   */
  removeItems(ids) {
    ids.forEach((id) => {
      const item = this.items[id];
      if (!item)
        return;
      item.onChange.disconnectAll();
      this.innerView.removeChild(item);
      this.items.splice(id, 1);
    });
  }
  /**
   * Select item by ID.
   * @param id
   */
  selectItem(id) {
    this.items.forEach((item, key) => {
      item.forceCheck(key === id);
    });
    if (this.selected !== id) {
      this.onChange.emit(id, this.items[id].label.text);
    }
    this.value = this.options.items[id].label.text;
    this.selected = id;
  }
}

exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map
